import { fmtL, fmtTime } from "@/lib/api";
import { PageHeader, Spinner, TeamBadge, PlayerAvatar, Badge } from "@/components/opl/Common";
import { useList } from "@/components/opl/Crud";

export default function Squads() {
  const [teams] = useList("/reports/teams");
  const [cats] = useList("/categories");
  if (!teams) return <Spinner />;
  const cmap = Object.fromEntries((cats || []).map((c) => [c.id, c.name]));
  return (
    <div>
      <PageHeader title="Team Squads" crumbs={["Squads"]} />
      <div className="grid xl:grid-cols-2 gap-5" data-testid="squads-list">
        {teams.map((t) => (
          <div key={t.id} className="surface rounded-2xl p-5" data-testid={`squad-${t.code}`}>
            <div className="flex items-center gap-3">
              <TeamBadge team={t} size={44} />
              <div className="flex-1 min-w-0"><h3 className="font-bold text-lg truncate">{t.name}</h3><p className="text-xs text-slate-400">Owner {t.owner_name}</p></div>
              <div className="text-right text-sm"><div className="num font-bold text-[#F5D061]">{fmtL(t.remaining_purse)}</div><div className="text-xs text-slate-500">spent {fmtL(t.spent)}</div></div>
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              <span className="text-xs bg-white/5 rounded-full px-3 py-1">Squad <b className="num">{t.players.length}</b></span>
              {Object.entries(t.roles).map(([r, n]) => <span key={r} className="text-xs bg-white/5 rounded-full px-3 py-1">{r}: <b>{n}</b></span>)}
              {!t.reconciled && <Badge className="text-red-300 border-red-500/40">Ledger mismatch</Badge>}
            </div>
            {t.warnings.map((w) => <p key={w} className="text-xs text-orange-300 mt-2" data-testid="squad-warning">⚠ {w}</p>)}
            <div className="mt-4 space-y-1.5">
              {t.players.map((p) => (
                <div key={p.id} className="flex items-center gap-3 bg-white/[0.02] rounded-lg p-2 text-sm">
                  <PlayerAvatar player={p} size={34} />
                  <div className="flex-1 min-w-0"><div className="font-semibold truncate">{p.name}</div><div className="text-[11px] text-slate-500">{p.role} · {cmap[p.category_id]} · Round {p.round || 1} · {fmtTime(p.purchased_at)}</div></div>
                  <span className="num font-bold">{fmtL(p.purchase_price)}</span>
                </div>
              ))}
              {!t.players.length && <p className="text-sm text-slate-500">No purchases yet</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
